export const getServiceList = () => {
	return {
		method: "GET",
		url: `${process.env.REACT_APP_ORIGIN}/service/`,
	}
}
